import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const agentThemeStyleId = 'wb-agent-theme';

export const agentThemeBridgeStyles = {
  ':root': {
    // ─── Surfaces ────────────────────────────────────────────────────────────────
    '--color-bg-primary': tokens.color.background.primary,
    '--color-bg-primary-hover': tokens.color.background.primaryHover,
    '--color-bg-secondary': tokens.color.background.secondary,
    '--color-bg-tertiary': tokens.color.background.tertiary,
    '--color-bg-quaternary': tokens.color.background.quaternary,

    // ─── Text ────────────────────────────────────────────────────────────────────
    '--color-text-primary': tokens.color.text.primary,
    '--color-text-secondary': tokens.color.text.secondary,
    '--color-text-tertiary': tokens.color.text.tertiary,
    '--color-text-placeholder': tokens.color.text.placeholder,
    '--color-text-quaternary': tokens.color.text.quaternary,
    '--color-text-white': tokens.color.text.white,

    // ─── Foreground (Icons) ──────────────────────────────────────────────────────
    '--color-fg-secondary': tokens.color.foreground.secondary,
    '--color-fg-tertiary': tokens.color.foreground.tertiary,
    '--color-fg-quaternary': tokens.color.foreground.quaternary,
    '--color-fg-white': tokens.color.foreground.white,
    '--color-fg-navy': tokens.color.foreground.brandPrimary,
    '--color-fg-gray-700': tokens.componentColors.utility.gray700,

    // ─── Accent / Brand ─────────────────────────────────────────────────────────
    '--color-bg-brand-solid': tokens.color.background.brandSolid,
    '--color-bg-brand-primary': tokens.color.background.brandPrimary,
    '--color-bg-brand-secondary': tokens.color.background.brandSecondary,
    '--color-text-brand-secondary': tokens.color.text.brandSecondary,
    '--color-utility-brand-600': tokens.componentColors.utility.brand600,
    '--color-utility-success-600': tokens.componentColors.utility.success600,

    // ─── Error ──────────────────────────────────────────────────────────────────
    '--color-error-bg': tokens.color.background.errorPrimary,
    '--color-error-border': tokens.color.border.error,
    '--color-error-text': tokens.color.text.errorPrimary,
    '--color-error': tokens.color.background.errorSolid,

    // ─── Borders ────────────────────────────────────────────────────────────────
    '--color-border-primary': tokens.color.border.primary,
    '--color-border-secondary': tokens.color.border.secondary,
    '--color-border-brand': tokens.color.border.brand,

    // ─── Shadows ────────────────────────────────────────────────────────────────
    '--shadow-xs': tokens.shadow.xs,
    '--shadow-sm': tokens.shadow.sm,
    '--shadow-lg': tokens.shadow.lg,
    '--ring-gray': tokens.shadow.ringGray6px,
    '--color-effects-shadow-xs': tokens.color.effects.shadows.shadowXs,

    // ─── Alpha ──────────────────────────────────────────────────────────────────
    '--alpha-white-80': tokens.componentColors.alpha.white80,

    // ─── Font Family ────────────────────────────────────────────────────────────
    '--font-family-body': tokens.font.family.body,
    '--font-family-display': tokens.font.family.display,

    // ─── Font Sizes ─────────────────────────────────────────────────────────────
    '--font-size-text-xs': tokens.font.size.textXs,
    '--font-size-text-sm': tokens.font.size.textSm,
    '--font-size-text-md-base': tokens.font.size.textMdBase,
    '--font-size-display-xs': tokens.font.size.displayXs,
    '--font-size-display-sm': tokens.font.size.displaySm,
    '--font-size-display-lg': tokens.font.size.displayLg,

    // ─── Font Weights ───────────────────────────────────────────────────────────
    '--font-weight-regular': tokens.font.weight.regular,
    '--font-weight-medium': tokens.font.weight.medium,
    '--font-weight-semibold': tokens.font.weight.semibold,

    // ─── Line Heights ───────────────────────────────────────────────────────────
    '--line-height-text-sm': tokens.lineHeight.textSm,
    '--line-height-text-md': tokens.lineHeight.textMd,
    '--line-height-display-xs': tokens.lineHeight.displayXs,
    '--line-height-display-sm': tokens.lineHeight.displaySm,
    '--line-height-display-lg': tokens.lineHeight.displayLg,

    // ─── Spacing Scale ──────────────────────────────────────────────────────────
    '--spacing-xxs': tokens.spacing.xxs,
    '--spacing-xs': tokens.spacing.xs,
    '--spacing-sm': tokens.spacing.sm,
    '--spacing-md': tokens.spacing.md,
    '--spacing-md-alt': tokens.spacing.mdAlt,
    '--spacing-lg': tokens.spacing.lg,
    '--spacing-xl': tokens.spacing.xl,
    '--spacing-2xl': tokens.spacing.twoXl,
    '--spacing-3xl': tokens.spacing.threeXl,
    '--spacing-5xl': tokens.spacing.fiveXl,

    // ─── Border Radius ──────────────────────────────────────────────────────────
    '--radius-xs': tokens.radius.xs,
    '--radius-sm': tokens.radius.sm,
    '--radius-md': tokens.radius.md,
    '--radius-xl': tokens.radius.xl,
    '--radius-full': tokens.radius.full,

    // ─── Focus Ring ─────────────────────────────────────────────────────────────
    '--focus-ring': tokens.focusRing.default,
  },
};
